module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13606/images/hublet-eu.svg"